<template>
    <div class="header">
      <div v-on:click="toHome" class="mt-3 ml-5 lg:visible invisible">
        <img src="../assets/header_logo.png" alt="logo">
      </div>
      <div class="header-menu invisible lg:visible">
        <router-link class="mr-8" to="/">Home</router-link>
        <router-link class="mr-8" to="/about">About</router-link>
        <router-link class="mr-8" to="/share-farm">シェア農家</router-link>
        <router-link class="mr-8" to="/events">イベント</router-link>
        <router-link class="mr-8" to="/products">商品一覧</router-link>
        <router-link class="mr-8" to="/online-seminar">オンライン説明会</router-link>
        <!-- <router-link class="mr-8" to="/contact">Contact</router-link> -->
        <router-link class="mr-8" to="/company">会社概要</router-link>
      </div>
      <button type="button" @click="switchMobileMenu" class="mobile-menu-btn absolute items-center lg:hidden right-1 top-5">
        <ion-icon name="menu-outline" class="menu-outline"></ion-icon>
      </button>
      <div class="mobile-menu bg-white absolute w-full h-full">
        <button type="button" @click="switchMobileMenu" class="mobile-menu-hidden-btn absolute items-center lg:hidden right-1 top-5">
          <ion-icon name="close-outline" class="close-outline"></ion-icon>
        </button>
        <hr>
        <div class="inline-grid">
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/">Home</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/about">About</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/share-farm">シェア農家</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/events">イベント</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/online-seminar">オンライン説明会</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/products">商品一覧</router-link>
          <router-link @click="switchMobileMenu" class="mobile-menu-text" to="/company">会社概要</router-link>

        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
  props: {},
  methods: {
    toHome() {
      this.$router.push("/");
    },
    switchMobileMenu() {
      var mmb = document.getElementsByClassName("mobile-menu")[0];
      if (mmb.style.visibility == "visible") {
        mmb.style.visibility = "hidden";
      } else {
        mmb.style.visibility = "visible";
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #AF9453;
}
hr {
  position: relative;
  margin: 20vw auto 3vw;
  width: 80%;
}
.header {
  display: inline-flex;
  width: 100%;
  height: 92px;
}
.header-menu {
  position: absolute;
  top: 2.3vw;
  right: 3vw;
}
.admin-fade-in {
  animation-name:fadeInAnime;
  animation-duration:1s;
  animation-fill-mode:forwards;
  opacity:0;
}
.mobile-menu {
  z-index: 900;
  visibility: hidden;
}
.mobile-menu-text {
  font-size: 5vw;
  line-height: 10vw;
}
.menu-outline,
.close-outline {
  width: 3rem;
  height: 3rem;
  color: #AF9453;
}
@keyframes fadeInAnime{
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
